import { NgModule } from '@angular/core';
import { ManagerComponent } from './manager.component';
import { HeaderModule } from 'src/app/controls/header/header.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgxMaskModule, IConfig } from 'ngx-mask';
export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;
@NgModule({
    declarations: [ManagerComponent],
    imports: [HeaderModule, CommonModule, FormsModule, NgxMaskModule.forRoot()],
    exports: [ManagerComponent],
    providers: [],
    bootstrap: [ManagerComponent]
})
export class ManagerModule { }